import { Component, OnInit, EventEmitter, ViewChild, Inject } from '@angular/core';
import { generalService } from '../../services/general.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ClienteSAE } from '../../models/cliente-sae';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TipoCliente } from '../../models/tipo-cliente';
import { MatOptionSelectionChange, MatSort, MatPaginator, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Pais } from '../../models/pais';
import { Estado } from '../../models/estado';
import { Ciudad } from '../../models/ciudad';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { DataService } from '../../utils/data.service';
import { direccionAddEditComponent } from './direcciones/direccionAddEdit.component';
import { contactoAddEditComponent } from './contactos/contactoAddEddit.component';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaUsoCFDI } from '../../models/facturaUsoCFDI';

@Component({
  selector: 'app-cliente-sae-agregar-editar',
  templateUrl: './cliente-sae-agregar-editar.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class ClienteSaeAgregarEditarComponent implements OnInit {
  dataDirecciones: DataSourceGrid | null;
  dataContactos: DataSourceGrid | null;
  displayedColumns = ['acciones', 'alias', 'pais', 'estado', 'ciudad', 'colonia'];
  tablaContactos = ['acciones', 'nombreCompleto', 'correoElectronico', 'numeroTelefonico'];
  public direcciones: Array<any>;
  public hayDirecciones: boolean = false;
  public contactos: Array<any>;
  public hayContactos: boolean = false;
  public guardandoCliente: boolean = false;
  public datosGeneralesSAE: any;
  listaRegimenFiscal: FacturaRegimenFiscal[] = [];
  listaCFDI: FacturaUsoCFDI[] = [];

  public titulo = '';
  public esActualizacion = false;
  public formularioCliente: FormGroup;

  private idCliente: string;
  private loacs: string;
  private cliente: ClienteSAE;
  timeout: any;

  public opcionesIdioma = ['Español (México)', 'Ingles'];
  public opcionesTipoPersona = [
    {nombre: 'Física', valor: 0},
    {nombre: 'Moral', valor: 1}
  ];
  public opcionesManejaCredito = [
    {nombre: 'Si', valor: 1},
    {nombre: 'No', valor: 0}
  ];
  public paises: Pais[] = [];
  public estados: Estado[] = [];
  public estadosPorPais: Estado[] = [];
  public ciudades: Ciudad[] = [];
  public ciudadesPorEstado: Ciudad[] = [];
  public localidad: any[] = [];
  public localidadesPorEstado: any[] = [];
  public postalCode: any[] = [];
  public postalCodeEstado: any[] = [];
  public suburb: any[] = [];
  public suburbAux: any[] = [];
  vistaBtn : boolean;
  public tiposCliente: TipoCliente;

  public parametroUrl:any;
  public webServ:string;

  constructor(private _generalService: generalService,
              private formBuilder: FormBuilder,
              private router: Router,
              public dataService: DataService,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public dialogData: any,
              public dialogRef: MatDialogRef<ClienteSaeAgregarEditarComponent>,
              private route: ActivatedRoute) {
    this.datosGeneralesSAE = DatosGeneralesSAE;
    this.idCliente = this.route.snapshot.paramMap.get('id');
    this.loacs = sessionStorage.getItem('acslo');
    this.direcciones = new Array();
    this.contactos = new Array();
    this.route.params.forEach((params: Params)=>{
      this.parametroUrl = params['parametro'];
      console.log(this.parametroUrl);
    });
  }
  

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sortII: MatSort;
  @ViewChild(MatPaginator) paginatorII: MatPaginator;

  ngOnInit() {
    this.buildForm();
    this.getDataFilters();
    const tiposCliente = this.consultarTiposCliente();
    const paises = this.consultarPaises();
    const estados = this.consultarEstados();
    const ciudades = this.consultarCiudades();
    const localidades = this.consultarLocalidad();
    const suburb = this.consultarSuburb();
    const listaRegimenFiscal = this.consultarRegimenFiscal();
    const listaCFDI = this.consultarUsoCFDI();

    forkJoin(tiposCliente, paises, estados, ciudades)
    .subscribe((ok) => {
      this.initNewOrUpdate();
    }, (error) => {
      console.log(error);
    });
  }

  buildForm() {
    this.formularioCliente = this.formBuilder.group({
      razonSocial: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
      RFC: this.formBuilder.control(null, [Validators.maxLength(20)]),
      numeroCliente: this.formBuilder.control({value: null, disabled: true}, [Validators.maxLength(30)]),
      email: this.formBuilder.control(null, [Validators.maxLength(500)]),
      nombreCorto: this.formBuilder.control(null, [Validators.maxLength(50)]),
      tipoPersona: this.formBuilder.control(null, [Validators.required]),
      lenguaje: this.formBuilder.control(null, []),
      tipoCliente: this.formBuilder.control(null, [Validators.required]),
      manejaCredito: this.formBuilder.control(null, [Validators.required]),
      diasCredito: this.formBuilder.control({value: null, disabled: true}, [Validators.required, Validators.min(1), Validators.max(999999999)]),
      lada: this.formBuilder.control(null, [Validators.maxLength(10)]),
      telefono: this.formBuilder.control(null, [Validators.maxLength(20)]),
      pais: this.formBuilder.control(null, []),
      estado: this.formBuilder.control(null, []),
      ciudad: this.formBuilder.control(null, []),
      LOCATION: this.formBuilder.control(null, []),
      SUBURB: this.formBuilder.control(null, []),
      POSTAL_CODE: this.formBuilder.control(null, []),
      colonia: this.formBuilder.control(null, [Validators.maxLength(100)]),
      calle: this.formBuilder.control(null, [Validators.maxLength(100)]),
      numExterior: this.formBuilder.control(null, [Validators.maxLength(20)]),
      codigoPostal: this.formBuilder.control(null, [Validators.maxLength(20)]),
      regimenFiscal: this.formBuilder.control(null, []),
      usoCFDI: this.formBuilder.control(null, []),
    });
  }

  initNewOrUpdate() {
    if (this.idCliente === 'N' || (this.dialogData && this.dialogData.esModal)){
      if( this.parametroUrl == ':parametro' || this.dialogData.agregar == 1 )
      {
        this.titulo = 'Nuevo Proveedor';
      }
      else
      {
        this.titulo = 'Nuevo Cliente';
      }
      this.esActualizacion = false;
      this.cliente = new ClienteSAE();
    } else {
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.consultarCliente();
    }
  }

  consultarTiposCliente(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`tipoCliente/consultarTiposCliente`)
          .subscribe((tiposCliente) => {
            if (tiposCliente && tiposCliente.length > 0) {
              this.tiposCliente = tiposCliente;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarPaises(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarPaises`)
          .subscribe((paises) => {
            if (paises && paises.length > 0) {
              this.paises = paises;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarRegimenFiscal(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`factura/getRegimenFiscal/`)
          .subscribe((regimen) => {
            if (regimen && regimen.length > 0) {
              const res = JSON.parse(regimen);
              this.listaRegimenFiscal = res;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

    consultarUsoCFDI(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`factura/getUsoCFDI/`)
          .subscribe((UsoCFDI) => {
            if (UsoCFDI && UsoCFDI.length > 0) {
              const res = JSON.parse(UsoCFDI);
              this.listaCFDI = res;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarEstados(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarEstados`)
          .subscribe((estados) => {
            if (estados && estados.length > 0) {
              this.estados = estados;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarCiudades(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarCiudades`)
          .subscribe((ciudades) => {
            if (ciudades && ciudades.length > 0) {
              this.ciudades = ciudades;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }
  consultarLocalidad(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarLocalidad`)
          .subscribe((localidad) => {
            if (localidad && localidad.length > 0) {
              this.localidad = localidad;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }
  consultarPostalCode(idEstado, bandera): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarpostalCodeByState?idState=${idEstado}`)
          .subscribe((postalCode) => {
            if (postalCode && postalCode.length > 0) {
              this.postalCode = postalCode;
             // this.postalCodeAux = postalCode;
            if(this.cliente.POSTAL_CODE_ID == null){
              this.postalCodeEstado = this.postalCode.filter(cp => cp.STATE_ID === idEstado).slice(0, 10);
            }
            else
            {
              this.postalCodeEstado = this.postalCode.filter(cp => cp.STATE_ID === idEstado).slice(0, 10);
              // Verificar si this.cliente.POSTAL_CODE_ID cumple con la condición y agregarlo a this.postalCodeEstado para que salga en el listado  
              const clientePostalCodeId = this.cliente.POSTAL_CODE_ID;
              if (clientePostalCodeId) {
                const found = this.postalCodeEstado.find(cp => cp.POSTAL_CODE_ID === clientePostalCodeId);
                if (!found) {
                    const postalCodeCliente = this.postalCode.find(cp => cp.POSTAL_CODE_ID === clientePostalCodeId);
                    if (postalCodeCliente) {
                        this.postalCodeEstado.push(postalCodeCliente);
                    }
                }
              }
            }
            this.postalCodeAux = this.postalCode.filter((cp) => cp.STATE_ID === idEstado);
            if(bandera == true){
              this.establecerDatosClienteFormulario();
            }
            
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }
  consultarSuburb(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(`direccion/consultarSuburb`)
          .subscribe((suburb) => {
            if (suburb && suburb.length > 0) {
              this.suburb = suburb;
            }
            resolve();
          }, (error: any) => {
            console.log(error);
            this._generalService.toastCall(error);
            reject();
          });
    });
  }

  consultarCliente() {
    if(this.parametroUrl == ':parametro')
    {
      this.webServ = 'clienteSAE/consultarProveedor';
    }
    else
    {
      this.webServ = 'clienteSAE/consultarCliente';
    }
    this._generalService.metodoCall(this.webServ + `?idCliente=${this.idCliente}`)
        .subscribe((cliente) => {
          if (cliente && cliente.length > 0) {
            this.cliente = cliente[0];
            if(this.parametroUrl == ':parametro')
            {
              this.titulo = `Proveedor ${this.cliente.nombre}`;
            }
            else
            {
              this.titulo = `Cliente ${this.cliente.nombre}`;
            }
            this.esActualizacion = true;
            this.consultarDirecciones();
            this.consultarContactos();
            if(this.cliente.idEstado != null)
            {
              const postalCode = this.consultarPostalCode(this.cliente.idEstado, true);
            }
            else
            {
              this.establecerDatosClienteFormulario();
            }
            this.datosGeneralesSAE.showSpinnerLoading = false;
          } else {
            this.router.navigate(['../', 'N'], {relativeTo: this.route });
          }
        }, (error: any) => {
          console.log(error);
          this._generalService.toastCall(error);
        });
  }

  establecerDatosClienteFormulario() {
    this.formularioCliente.controls['razonSocial'].setValue(this.cliente.nombre);
    this.formularioCliente.controls['RFC'].setValue(this.cliente.RFC);
    this.formularioCliente.controls['numeroCliente'].setValue(this.cliente.numeroCliente);
    this.formularioCliente.controls['email'].setValue(this.cliente.email);
    this.formularioCliente.controls['nombreCorto'].setValue(this.cliente.nombreCorto)
    this.formularioCliente.controls['tipoPersona'].setValue(this.cliente.tipoPersona);
    this.formularioCliente.controls['lenguaje'].setValue(this.cliente.lenguaje);
    this.formularioCliente.controls['tipoCliente'].setValue(this.cliente.idTipoCliente);
    this.formularioCliente.controls['manejaCredito'].setValue(this.cliente.manejaCredito);
    this.formularioCliente.controls['diasCredito'].setValue(this.cliente.diasCredito);
    this.formularioCliente.controls['lada'].setValue(this.cliente.lada);
    this.formularioCliente.controls['telefono'].setValue(this.cliente.telefono);
    this.formularioCliente.controls['pais'].setValue(this.cliente.idPais);
    this.formularioCliente.controls['estado'].setValue(this.cliente.idEstado);
    this.formularioCliente.controls['ciudad'].setValue(this.cliente.idCiudad);
    this.formularioCliente.controls['colonia'].setValue(this.cliente.colonia);
    this.formularioCliente.controls['LOCATION'].setValue(this.cliente.LOCATION_ID);
    this.formularioCliente.controls['SUBURB'].setValue(this.cliente.SUBURB_ID);
    this.formularioCliente.controls['POSTAL_CODE'].setValue(this.cliente.POSTAL_CODE_ID);
   
    this.formularioCliente.controls['calle'].setValue(this.cliente.calle);
    this.formularioCliente.controls['numExterior'].setValue(this.cliente.numExterior);
    this.formularioCliente.controls['codigoPostal'].setValue(this.cliente.codigoPostal);
    this.formularioCliente.controls['regimenFiscal'].setValue(this.cliente.BILL_TAX_REGIME_ID);
    this.formularioCliente.controls['usoCFDI'].setValue(this.cliente.BILL_CFDI_USE_ID);
    
  }

  guardarCliente() {
    this. guardandoCliente = true;
    this.mapearDatosFormularioEnModelo();
    if (this.esActualizacion) {
      this.editarCliente();
    } else {
      this.agregarCliente();
    }
  }

  mapearDatosFormularioEnModelo() {
    this.cliente.nombre = this.formularioCliente.controls['razonSocial'].value;
    this.cliente.RFC = this.formularioCliente.controls['RFC'].value;
    this.cliente.numeroCliente = this.formularioCliente.controls['numeroCliente'].value;
    this.cliente.email = this.formularioCliente.controls['email'].value;
    this.cliente.nombreCorto = this.formularioCliente.controls['nombreCorto'].value;
    this.cliente.tipoPersona = this.formularioCliente.controls['tipoPersona'].value;
    this.cliente.lenguaje = this.formularioCliente.controls['lenguaje'].value;
    this.cliente.idTipoCliente = this.formularioCliente.controls['tipoCliente'].value;
    this.cliente.manejaCredito = this.formularioCliente.controls['manejaCredito'].value;

    if (this.cliente.manejaCredito) {
      this.cliente.diasCredito = this.formularioCliente.controls['diasCredito'].value;
    } else {
      this.cliente.diasCredito = null;
    }

    this.cliente.lada =  this.formularioCliente.controls['lada'].value;
    this.cliente.telefono = this.formularioCliente.controls['telefono'].value;
    this.cliente.idPais = this.formularioCliente.controls['pais'].value;
    this.cliente.idEstado = this.formularioCliente.controls['estado'].value;
    this.cliente.idCiudad = this.formularioCliente.controls['ciudad'].value;
    this.cliente.colonia = this.formularioCliente.controls['colonia'].value;
    this.cliente.LOCATION_ID = this.formularioCliente.controls['LOCATION'].value;
    this.cliente.SUBURB_ID = this.formularioCliente.controls['SUBURB'].value;
    this.cliente.POSTAL_CODE_ID = this.formularioCliente.controls['POSTAL_CODE'].value;
    
    this.cliente.calle = this.formularioCliente.controls['calle'].value;
    this.cliente.numExterior = this.formularioCliente.controls['numExterior'].value;
    this.cliente.codigoPostal = this.formularioCliente.controls['codigoPostal'].value;
    this.cliente.BILL_TAX_REGIME_ID = this.formularioCliente.controls['regimenFiscal'].value != 0 ? this.formularioCliente.controls['regimenFiscal'].value : null;
    this.cliente.BILL_CFDI_USE_ID = this.formularioCliente.controls['usoCFDI'].value != 0 ? this.formularioCliente.controls['usoCFDI'].value : null;

    this.cliente.loacs = this.loacs;
  }

  editarCliente() {
    console.log(this.cliente);
    this._generalService.metodoCallParams(this.cliente, 'clienteSAE/actualizarCliente', true)
        .subscribe((result) => {
          this._generalService.toastCall(result.message);

          if (this.dialogData && this.dialogData.esModal) {
            this.dataService.guardado = true;   }

          this.datosGeneralesSAE.showSpinnerLoading = false;
          this.guardandoCliente = false;
        }, (error) => {
          console.log(error as any);
        });
  }


  agregarCliente() {
    if(this.parametroUrl == ':parametro' || this.dialogData.agregar == 1 )
    {
      this.webServ = 'clienteSAE/agregarProveedor';
    }
    else
    {
      this.webServ = 'clienteSAE/agregarCliente';
    }
    this._generalService.metodoCallParams(this.cliente, this.webServ, true)
        .subscribe((result) => {
          this._generalService.toastCall(result.message);
          this.idCliente = result.data;
          this.cliente.idCliente = result.data;
          this.esActualizacion = true;

          if (this.dialogData && this.dialogData.esModal) {
            this.dataService.guardado = true;   } 

          this.consultarNumeroCliente();
          this.guardandoCliente = false;
        }, (error) => {
          console.log(error as any);
        });
  }

  regresar() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  habilitarDiasCredito(opcion: MatOptionSelectionChange) {
    if (opcion.isUserInput) {
      if (opcion.source.value === 1) {
        this.formularioCliente.controls['diasCredito'].enable();
      } else if (opcion.source.value === 0) {
        this.formularioCliente.controls['diasCredito'].disable();
      }
    }
  }

  filtrarEstados(opcion: MatOptionSelectionChange) {
    if (opcion.isUserInput) {
      const idPais = opcion.source.value;

      if (this.formularioCliente.controls['pais'].value !== idPais) {
        this.formularioCliente.controls['estado'].setValue(null);
        this.formularioCliente.controls['ciudad'].setValue(null);
      }
      this.estadosPorPais = this.estados.filter((estado) => estado.idPais === idPais);
      this.ciudadesPorEstado = [];
    }
  }

  filtrarCiudades(opcion: MatOptionSelectionChange) {
    if (opcion.isUserInput) { 
      const idEstado = opcion.source.value;

      if (this.formularioCliente.controls['estado'].value !== idEstado) {
        this.formularioCliente.controls['ciudad'].setValue(null);
        this.formularioCliente.controls['LOCATION'].setValue(null);
        this.formularioCliente.controls['POSTAL_CODE'].setValue(null);
      }
      this.ciudadesPorEstado = this.ciudades.filter((ciudad) => ciudad.idEstado === idEstado);
      this.localidadesPorEstado = this.localidad.filter((localidad) => localidad.STATE_ID === idEstado);
      
      
        this.consultarPostalCode(idEstado, false);
      
    }
  }
  public postalCodeAux: any[] = [];
  public codigoPostalAUX: any[] = [];
  // filtroCp(val: any) {
  //   let arr: any[];
  //   if (val.currentTarget.value.trim() !== "") {
  //     arr = this.postalCodeAux.filter((obj) => {
  //       return obj.NAME.toLowerCase().indexOf(val.currentTarget.value.trim().toLowerCase()) > -1;
  //     });
  //   } else {
  //     arr = this.postalCodeAux.slice(0, 10); // Restaurar a los primeros 10 elementos
  //   }
  //   this.postalCodeEstado = arr;
  // }
  
  
  filtroCp(val: any) {
    

    if (this.timeout) {
        clearTimeout(this.timeout);
    }

    const searchValue = val.currentTarget.value.trim().toLowerCase();
    this.timeout = setTimeout(() => {
        

        let arr: any[];

        if (searchValue !== "") {
            arr = this.postalCodeAux
                .filter((obj) => obj.NAME.toLowerCase().indexOf(searchValue) > -1)
                .slice(0, 10); // Limitar a los primeros 10 elementos
        } else {
            arr = this.postalCodeAux.slice(0, 10); // Restaurar a los primeros 10 elementos del array original
        }
        
        //console.log("filtroCp: Resultado filtrado:", arr);
        this.postalCodeEstado = arr;
    }, 300); // Esperar 300 ms antes de ejecutar la búsqueda

    
  }



  filtrarSuburb(opcion: MatOptionSelectionChange){
    if (opcion.isUserInput) {
      const POSTAL_CODE_ID = opcion.source.value;

      if (this.formularioCliente.controls['POSTAL_CODE'].value !== POSTAL_CODE_ID) {
        this.formularioCliente.controls['SUBURB'].setValue(null);
  
      }
      this.suburbAux = this.suburb.filter((suburb) => suburb.POSTAL_CODE_ID === POSTAL_CODE_ID);
    }
  }
  consultarDirecciones(){
    this.hayDirecciones = true;

    this._generalService.metodoCallParams(this.idCliente, 'direccion/consultarDirecciones')
      .subscribe((result) => {
        this.direcciones = result;
        this.dataDirecciones = new DataSourceGrid(this.direcciones, this.paginator, this.sort);
        if (this.direcciones.length <= 0) {
          this.dataDirecciones = undefined;
          this.hayDirecciones = false; }
        }, 
      (error) => {
        console.log(error);
        this._generalService.toastCall(error);  
    });
  }

  eliminarDireccion(direccion) {
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.consultarDirecciones();
    });
    this._generalService.modal(eliminarHttp,
                               'confirm',
                               `¿Desea eliminar la dirección ${direccion.alias}?`,
                               'direccion/eliminarDireccion',
                               direccion.idDireccion);
  }

  agregarDireccion() {
    if (this.esActualizacion == false) {
      this._generalService.toastCall('Guarde primero los datos generales del cliente'); 
    } else {
      this.dataService.tipo = "agregar";
      this.dataService.idCliente = this.idCliente;
      const dialogRef = this.dialog.open(direccionAddEditComponent, {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog',
        data: { 
          vistaBtn: this.vistaBtn
        }
      });
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
        if(this.dataService.guardado){
          this._generalService.toastCall("El registro se agregó exitosamente!");
          this.consultarDirecciones();
        } 
      });
    }
  }

  editarDireccion(idDireccion){
    this.dataService.tipo = "editar";
    this.dataService.idCliente = this.idCliente;
    this.dataService.id = idDireccion;
    const dialogRef = this.dialog.open(direccionAddEditComponent, {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog',
      data: { 
        vistaBtn: this.vistaBtn
      }
    });
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El registro se modificó exitosamente!");
        this.consultarDirecciones();     
      }
      else if(this.dataService.mensajeAlert != "" && this.dataService.mensajeAlert != undefined){
        this._generalService.toastCall(this.dataService.mensajeAlert);
      }
    });
  }

  consultarContactos(){
    this.hayContactos = true;

    this._generalService.metodoCallParams(this.idCliente, 'Contacto/consultarContactos')
      .subscribe((result) => {
        this.contactos = result;
        this.dataContactos = new DataSourceGrid(this.contactos, this.paginatorII, this.sortII);
        if (this.contactos.length <= 0) {
          this.dataContactos = undefined;
          this.hayContactos = false; }
        }, 
      (error) => {
        console.log(error);
        this._generalService.toastCall(error);  
    });
  }

  eliminarContacto(contacto) {
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.consultarContactos();
    });
    this._generalService.modal(eliminarHttp, 'confirm',
                               `¿Desea eliminar la dirección ${contacto.nombreCompleto}?`,
                               'direccion/eliminarDireccion', contacto.idContacto);
  }

  agregarContacto() {
    if (this.esActualizacion == false) {
      this._generalService.toastCall('Guarde primero los datos generales del cliente'); 
    } else {
      this.dataService.tipo = "agregar";
      this.dataService.idCliente = this.idCliente;
      const dialogRef = this.dialog.open(contactoAddEditComponent, 
        {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog'});
      this.dataService.dialogRef = dialogRef;
      dialogRef.afterClosed().subscribe((result) => {
        if(this.dataService.guardado){
          this._generalService.toastCall("El contacto se agregó exitosamente!");
          this.consultarContactos();
        } 
      });
    }
  }

  editarContacto(idContacto){
    this.dataService.tipo = "editar";
    this.dataService.idCliente = this.idCliente;
    this.dataService.id = idContacto;
    const dialogRef = this.dialog.open(contactoAddEditComponent, 
      {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El contacto ha sido actualizado");
        this.consultarContactos();     
      }
      else if(this.dataService.mensajeAlert != "" && this.dataService.mensajeAlert != undefined){
        this._generalService.toastCall(this.dataService.mensajeAlert);
      }
    });
  }

  cerrarModal(clienteNuevo) {
    this.dialogRef.close(clienteNuevo)
  }

  consultarNumeroCliente() {
    this._generalService.metodoCall(`clienteSAE/consultarCliente?idCliente=${this.idCliente}`)
        .subscribe((cliente) => {
          if (cliente && cliente.length > 0) {
            this.formularioCliente.controls['numeroCliente'].setValue(cliente[0].numeroCliente);
          } else {
            this._generalService.toastCall('Error al asignar Número de Cliente');
          }

          this.datosGeneralesSAE.showSpinnerLoading = false;
        }, (error: any) => {
          console.log(error);
          this._generalService.toastCall(error);
        });
  }
  
  getDataFilters() {
    
    let metodo = 'clienteSAE/validarCamposCartaPorte';
    const params = { 
        loacs: this.loacs
    };

    this._generalService.metodoCallParams(this.loacs, metodo).subscribe(
      result => {
        const tableResult = JSON.parse(result);
        //console.log(tableResult)
        if(tableResult[0].VALUE == '1'){
          this.vistaBtn = true;
        }else{
          this.vistaBtn = false;
        }
      },
      error => {  console.log(<any>error);  }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente-sae/cliente-sae-agregar-editar/cliente-sae-agregar-editar.component.ts